import {
  buildDownloadDataNew,
  getRegionByCode,
  getRegionByCountryCode,
  getCountryByCode,
} from '@/pages/intelligence/utils/commonUtils';
import { metricTitleMap } from '@intelligence/components/DownloadCommon/DownloadPage/common/baseConfig';
import moment from 'moment';
// import { ratioValueFormat, decimalFormat } from '@/pages/home/utils/common';
import { isIncludesSegmentValue } from '@/pages/intelligence/components/DownloadCommon/DownloadPage/utils';
import { getStdPlatform } from '../dataSettingAtom';
import {
  buildPlayersCountryPivotStatConfig,
  moveCountryDistributionStatColumnsLast,
  pivotPlayersByCountryTargetList,
  shouldPivotPlayersByCountry,
} from './buildPlayersCountryPivot';
import {
  buildMultiValuePriceDownloadColumns,
  expandMultiValueMetricsForDownloadSummary,
  getMultiValueMetricDownloadTitle,
} from '@intelligence/pages/TopCharts/utils/multiValueMetricUtils';
import {
  getOrderedMetricEntriesFromParams,
} from '@intelligence/components/DownloadCommon/DownloadPage/utils/reorderCombineDetailDownloadMetrics';

/** 与明细列一致的平台维度；用于分组 key，避免后端同一口径下 platform 空串与 Aggregated 并存时被拆成两行重复数据 */
const normalizePlatformForGroupKey = (item: any): string => {
  const raw = getStdPlatform(item?.platform, item?.device);
  if (raw === undefined || raw === null || raw === '') {
    return 'Aggregated';
  }
  return raw;
};

export function getCombineStatsAllMetricsConfig(list: any, params: any, allParams: any) {
  const config: any = {};
  const { regionOptions = [] } = allParams;
  // const { metric_condition = {} } = params;
  // const { mscience = {} } = metric_condition;
  // 是否展示%
  const isRatioShow = allParams?.ratio_show === 1;
  const data = list?.[0];
  if (!data) {
    return;
  }

  // console.log('getPCConsoleStatConfig-data', data);
  // console.log('getPCConsoleStatConfig-params', params);
  // console.log('getPCConsoleStatConfig-allParams', allParams);

  // 扁平化数据
  const groupKeys: string[] = [];
  if (params.b_group_by_date) {
    groupKeys.push('date');
  }
  if (params.b_group_by_region) {
    groupKeys.push('region');
  }
  if (params.b_group_by_market) {
    groupKeys.push('market');
  }
  if (params.b_group_by_platform) {
    groupKeys.push('platform');
  }
  const mp = {} as any;
  data?.metric_value_list?.forEach((item: any) => {
    const key = groupKeys
      ?.map((k) => (k === 'platform' ? normalizePlatformForGroupKey(item) : item[k]))
      .join('_');
    if (!mp[key]) {
      mp[key] = {};
      groupKeys?.forEach((itemKey) => {
        if (itemKey === 'platform') {
          mp[key][itemKey] = normalizePlatformForGroupKey(item);
          return;
        }

        mp[key][itemKey] = item[itemKey];
      });
    }
    // 特殊逻辑
    if (params.b_group_by_segment && item.segment) {
      // segment 需要散列
      mp[key][`metrics_${item.metric}_segment_${item.segment}`] = item.value;
      mp[key][`metrics_${item.metric}_segment_${item.segment}_growth`] =
        item.growth_ratio;
    } else {
      // 给指标赋值
      mp[key][`metrics_${item.metric}`] = item.value;
      // 如果需要判断是否有环比
      mp[key][`metrics_${item.metric}_growth`] = item.growth_ratio;
    }
  });
  // 处理成list
  const targetList = Object.values(mp);
  // console.log('targetListtargetList', targetList);
  // 如果需要排序
  // targetList.sort((a: any, b: any) => {
  //   // @yao 自己写排序
  //   if (params.b_group_by_date) {
  //     return a.date - b.date;
  //   }
  //   return 0;
  // });

  if (Array.isArray(targetList)) {
    targetList.sort((a: any, b: any) => {
      // 第一优先级：按 gameId 升序
      // if (a.game_id !== b.game_id) return a.game_id - b.game_id;
      // 第二优先级：按 time 降序（新时间在前）
      if (b.date !== a.date) return moment(b?.date).diff(moment(a?.date));
      // 第三优先级: 国家字母升序
      const deviceCompare = a?.market?.localeCompare(b?.market);
      if (a?.market && b?.market && deviceCompare !== 0) return deviceCompare;
      // 第四优先级：按 device 字母升序（A-Z）
      const mapOrder: any = {
        Aggregated: 0,
        PC: 1,
        PlayStation: 2,
        'PlayStation 4': 3,
        'PlayStation 5': 4,
        Xbox: 5,
        'Xbox One': 6,
        'Xbox Series X|S': 7,
        Nintendo: 8,
        'Nintendo Switch': 9,
        'Nintendo Will U': 10,
      };
      const deviceCompares = mapOrder[a?.platform] - mapOrder[b?.platform];
      if (deviceCompares !== 0) return deviceCompares;

      return 0;
    });
  }

  // 做一个指标缓存，用于快速判断
  // 如果有需要自己改
  const metricsCache = {} as any;
  for (const ds in params.source_metrics) {
    params.source_metrics[ds].forEach((item: any) => {
      metricsCache[item] = true;
    });
  }

  // stat 页
  const statConfig = [
    {
      title: 'Date',
      key: (item: any) =>
        params?.granularity === 'monthly'
          ? moment(item?.date).format('YYYY-MM')
          : item?.date || '',
      when: () => params.b_group_by_date,
    },
    {
      title: 'Region',
      key: (item: any) => {
        // 按地区拆分
        if (params?.b_group_by_region) {
          const regionCode = item?.region || '';
          const region = getRegionByCode(regionCode, regionOptions);
          return region?.area_name_en || region?.area_name_ch || regionCode;
        }

        // 按国家拆分
        const region = getRegionByCountryCode(item?.market, regionOptions);
        return region?.area_name_en || region?.area_name_ch || '';
      },
      when: () => params?.b_group_by_region || params?.b_group_by_market,
    },
    {
      title: 'Country_Chinese',
      key: (item: any) =>
        getCountryByCode(item?.market, regionOptions)
          ?.country_name_ch || item?.market || '',
      when: () => params?.b_group_by_market,
    },
    {
      title: 'Country_English',
      key: (item: any) =>
        getCountryByCode(item?.market, regionOptions)
          ?.country_name_en || item?.market || '',
      when: () => params?.b_group_by_market,
    },
    {
      title: 'Platform',
      key: (item: any) => item?.platform || '',
      when: () => params.b_group_by_platform,
    },
    // Databrain metrics
    {
      title: 'Total Revenue',
      key: (item: any) =>
        item?.metrics_databrain__total_revenue ||
        item?.metrics_databrain__total_revenue_segment_All ||
        '',
      when: () => metricsCache.databrain__total_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_databrain__total_revenue_growth ??
        item?.metrics_databrain__total_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.databrain__total_revenue && isRatioShow,
    },
    {
      title: 'Lifetime Total Revenue',
      key: (item: any) =>
        item?.metrics_databrain__lifetime_total_revenue ||
        item?.metrics_databrain__lifetime_total_revenue_segment_All ||
        '',
      when: () => metricsCache.databrain__lifetime_total_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_databrain__lifetime_total_revenue_growth ??
        item?.metrics_databrain__lifetime_total_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.databrain__lifetime_total_revenue && isRatioShow,
    },
    {
      title: 'Base Game Sales Units',
      key: (item: any) =>
        item?.metrics_databrain__base_game_sales_units ||
        item?.metrics_databrain__base_game_sales_units_segment_All ||
        '',
      when: () => metricsCache.databrain__base_game_sales_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_databrain__base_game_sales_units_growth ??
        item?.metrics_databrain__base_game_sales_units_segment_All_growth ??
        '',
      when: () => metricsCache.databrain__base_game_sales_units && isRatioShow,
    },
    {
      title: 'Lifetime Base Game Sales Units',
      key: (item: any) =>
        item?.metrics_databrain__lifetime_base_game_sales_units ||
        item?.metrics_databrain__lifetime_base_game_sales_units_segment_All ||
        '',
      when: () => metricsCache.databrain__lifetime_base_game_sales_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_databrain__lifetime_base_game_sales_units_growth ??
        item?.metrics_databrain__lifetime_base_game_sales_units_segment_All_growth ??
        '',
      when: () =>
        metricsCache.databrain__lifetime_base_game_sales_units && isRatioShow,
    },
    // Mscience lifetime metric
    {
      title: 'Mscience Digital Revenue',
      key: (item: any) => item?.metrics_digitalRevenue || '',
      when: () => metricsCache.digitalRevenue && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_digitalRevenue_growth || '',
      when: () =>
        metricsCache.digitalRevenue &&
        !params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(Aggregated)',
      key: (item: any) =>
        item?.metrics_digitalRevenue_segment_Aggregated ||
        item?.metrics_digitalRevenue_segment_All ||
        '',
      when: () => metricsCache.digitalRevenue && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_digitalRevenue_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.digitalRevenue && params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(Base Game)',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_Full Game'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('Full Game', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('Full Game', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(MTX)',
      key: (item: any) => item?.metrics_digitalRevenue_segment_MTX || '',
      when: () =>
        metricsCache.digitalRevenue && isIncludesSegmentValue('MTX', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_digitalRevenue_segment_MTX_growth || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('MTX', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(DLC: All Other)',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_DLC: All Other'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: All Other', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_DLC: All Other_growth'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: All Other', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(DLC: Expansion)',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_DLC: Expansion'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Expansion', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_DLC: Expansion_growth'] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Expansion', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(DLC: Battle Pass)',
      key: (item: any) =>
        item?.['metrics_digitalRevenue_segment_DLC: Unlockable Content Pass'] ||
        '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.[
          'metrics_digitalRevenue_segment_DLC: Unlockable Content Pass_growth'
          ] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(DLC: Season Pass)',
      key: (item: any) =>
        item?.[
          'metrics_digitalRevenue_segment_DLC: Content Pre-Purchase Pass'
          ] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.[
          'metrics_digitalRevenue_segment_DLC: Content Pre-Purchase Pass_growth'
          ] || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Revenue(Subscription)',
      key: (item: any) =>
        item?.metrics_digitalRevenue_segment_Subscription || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('Subscription', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_digitalRevenue_segment_Subscription_growth || '',
      when: () =>
        metricsCache.digitalRevenue &&
        isIncludesSegmentValue('Subscription', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Lifetime Digital Revenue',
      key: (item: any) =>
        item?.metrics_mscienceLifetimeDigitalRevenue ||
        item?.metrics_mscienceLifetimeDigitalRevenue_segment_All ||
        '',
      when: () => metricsCache.mscienceLifetimeDigitalRevenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_mscienceLifetimeDigitalRevenue_growth ??
        item?.metrics_mscienceLifetimeDigitalRevenue_segment_All_growth ??
        '',
      when: () => metricsCache.mscienceLifetimeDigitalRevenue && isRatioShow,
    },
    {
      title: 'Mscience Digital Units',
      key: (item: any) => item?.metrics_units || '',
      when: () => metricsCache.units && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_units_growth || '',
      when: () =>
        metricsCache.units && !params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Mscience Digital Units(Aggregated)',
      key: (item: any) => item?.metrics_units_segment_Aggregated || '',
      when: () => metricsCache.units && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_units_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.units && params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Mscience Digital Units(Base Game)',
      key: (item: any) => item?.['metrics_units_segment_Full Game'] || '',
      when: () =>
        metricsCache.units && isIncludesSegmentValue('Full Game', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_units_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('Full Game', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(MTX)',
      key: (item: any) => item?.metrics_units_segment_MTX || '',
      when: () => metricsCache.units && isIncludesSegmentValue('MTX', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_units_segment_MTX_growth || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('MTX', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(DLC: All Other)',
      key: (item: any) => item?.['metrics_units_segment_DLC: All Other'] || '',
      when: () =>
        metricsCache.units && isIncludesSegmentValue('DLC: All Other', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: All Other_growth'] || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: All Other', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(DLC: Expansion)',
      key: (item: any) => item?.['metrics_units_segment_DLC: Expansion'] || '',
      when: () =>
        metricsCache.units && isIncludesSegmentValue('DLC: Expansion', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: Expansion_growth'] || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: Expansion', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(DLC: Battle Pass)',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: Unlockable Content Pass'] || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: Unlockable Content Pass_growth'] ||
        '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(DLC: Season Pass)',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: Content Pre-Purchase Pass'] || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_units_segment_DLC: Content Pre-Purchase Pass_growth'] ||
        '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Digital Units(Subscription)',
      key: (item: any) => item?.metrics_units_segment_Subscription || '',
      when: () =>
        metricsCache.units && isIncludesSegmentValue('Subscription', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_units_segment_Subscription_growth || '',
      when: () =>
        metricsCache.units &&
        isIncludesSegmentValue('Subscription', params) &&
        isRatioShow,
    },
    {
      title: 'Mscience Lifetime Digital Units',
      key: (item: any) => item?.metrics_mscienceLifetimeDigitalUnits || item?.metrics_mscienceLifetimeDigitalUnits_segment_All|| '',
      when: () => metricsCache.mscienceLifetimeDigitalUnits,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_mscienceLifetimeDigitalUnits_growth ?? item?.metrics_mscienceLifetimeDigitalUnits_segment_All_growth ?? '',
      when: () => metricsCache.mscienceLifetimeDigitalUnits && isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)',
      key: (item: any) => item?.metrics_digitalARPPU || '',
      when: () => metricsCache.digitalARPPU && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_digitalARPPU_growth || '',
      when: () =>
        metricsCache.digitalARPPU && !params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(Aggregated)',
      key: (item: any) => item?.metrics_digitalARPPU_segment_Aggregated || '',
      when: () => metricsCache.digitalARPPU && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_digitalARPPU_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.digitalARPPU && params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(Base Game)',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_Full Game'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('Full Game', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('Full Game', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(MTX)',
      key: (item: any) => item?.metrics_digitalARPPU_segment_MTX || '',
      when: () =>
        metricsCache.digitalARPPU && isIncludesSegmentValue('MTX', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_digitalARPPU_segment_MTX_growth || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('MTX', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(DLC: All Other)',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: All Other'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: All Other', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: All Other_growth'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: All Other', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(DLC: Expansion)',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: Expansion'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Expansion', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: Expansion_growth'] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Expansion', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(DLC: Battle Pass)',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: Unlockable Content Pass'] ||
        '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.[
          'metrics_digitalARPPU_segment_DLC: Unlockable Content Pass_growth'
          ] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(DLC: Season Pass)',
      key: (item: any) =>
        item?.['metrics_digitalARPPU_segment_DLC: Content Pre-Purchase Pass'] ||
        '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.[
          'metrics_digitalARPPU_segment_DLC: Content Pre-Purchase Pass_growth'
          ] || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence Digital ARPPU($) (US only)(Subscription)',
      key: (item: any) => item?.metrics_digitalARPPU_segment_Subscription || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('Subscription', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_digitalARPPU_segment_Subscription_growth || '',
      when: () =>
        metricsCache.digitalARPPU &&
        isIncludesSegmentValue('Subscription', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST',
      key: (item: any) => item?.metrics_ast || '',
      when: () => metricsCache.ast && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ast_growth || '',
      when: () => metricsCache.ast && !params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Msicence AST(Aggregated)',
      key: (item: any) => item?.metrics_ast_segment_Aggregated || '',
      when: () => metricsCache.ast && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ast_segment_Aggregated_growth || '',
      when: () => metricsCache.ast && params.b_group_by_segment && isRatioShow,
    },
    {
      title: 'Msicence AST(Base Game)',
      key: (item: any) => item?.['metrics_ast_segment_Full Game'] || '',
      when: () =>
        metricsCache.ast && isIncludesSegmentValue('Full Game', params),
    },
    {
      title: '%',
      key: (item: any) => item?.['metrics_ast_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('Full Game', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(MTX)',
      key: (item: any) => item?.metrics_ast_segment_MTX || '',
      when: () => metricsCache.ast && isIncludesSegmentValue('MTX', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ast_segment_MTX_growth || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('MTX', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(DLC: All Other)',
      key: (item: any) => item?.['metrics_ast_segment_DLC: All Other'] || '',
      when: () =>
        metricsCache.ast && isIncludesSegmentValue('DLC: All Other', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: All Other_growth'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: All Other', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(DLC: Expansion)',
      key: (item: any) => item?.['metrics_ast_segment_DLC: Expansion'] || '',
      when: () =>
        metricsCache.ast && isIncludesSegmentValue('DLC: Expansion', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: Expansion_growth'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: Expansion', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(DLC: Battle Pass)',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: Unlockable Content Pass'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: Unlockable Content Pass_growth'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: Unlockable Content Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(DLC: Season Pass)',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: Content Pre-Purchase Pass'] || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_ast_segment_DLC: Content Pre-Purchase Pass_growth'] ||
        '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('DLC: Content Pre-Purchase Pass', params) &&
        isRatioShow,
    },
    {
      title: 'Msicence AST(Subscription)',
      key: (item: any) => item?.metrics_ast_segment_Subscription || '',
      when: () =>
        metricsCache.ast && isIncludesSegmentValue('Subscription', params),
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ast_segment_Subscription_growth || '',
      when: () =>
        metricsCache.ast &&
        isIncludesSegmentValue('Subscription', params) &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Units',
      key: (item: any) => item?.metrics_gsd_digitalUnits || '',
      when: () => metricsCache.gsd_digitalUnits && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_gsd_digitalUnits_growth || '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        !params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Units(Aggregated)',
      key: (item: any) => item?.metrics_gsd_digitalUnits_segment_All || '',
      when: () => metricsCache.gsd_digitalUnits && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gsd_digitalUnits_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Units(Base Game)',
      key: (item: any) =>
        item?.['metrics_gsd_digitalUnits_segment_Full Game'] || '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        isIncludesSegmentValue('Full Game', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_digitalUnits_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        isIncludesSegmentValue('Full Game', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Units(In-Game Currency)',
      key: (item: any) =>
        item?.['metrics_gsd_digitalUnits_segment_In-Game Currency'] || '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_digitalUnits_segment_In-Game Currency_growth'] ||
        '',
      when: () =>
        metricsCache.gsd_digitalUnits &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Units',
      key: (item: any) => item?.metrics_gsd_physicalUnits || '',
      when: () => metricsCache.gsd_physicalUnits && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_gsd_physicalUnits_growth || '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        !params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Units(Aggregated)',
      key: (item: any) =>
        item?.metrics_gsd_physicalUnits_segment_Aggregated || '',
      when: () => metricsCache.gsd_physicalUnits && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gsd_physicalUnits_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Units(Base Game)',
      key: (item: any) =>
        item?.['metrics_gsd_physicalUnits_segment_Full Game'] || '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        isIncludesSegmentValue('Full Game', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_physicalUnits_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        isIncludesSegmentValue('Full Game', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Units(In-Game Currency)',
      key: (item: any) =>
        item?.['metrics_gsd_physicalUnits_segment_In-Game Currency'] || '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_physicalUnits_segment_In-Game Currency_growth'] ||
        '',
      when: () =>
        metricsCache.gsd_physicalUnits &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Revenue(€)',
      key: (item: any) => item?.metrics_gsd_digitalRevenue || '',
      when: () => metricsCache.gsd_digitalRevenue && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_gsd_digitalRevenue_growth || '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        !params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Revenue(€)(Aggregated)',
      key: (item: any) =>
        item?.metrics_gsd_digitalRevenue_segment_Aggregated || '',
      when: () => metricsCache.gsd_digitalRevenue && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gsd_digitalRevenue_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Revenue(€)(Base Game)',
      key: (item: any) =>
        item?.['metrics_gsd_digitalRevenue_segment_Full Game'] || '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        isIncludesSegmentValue('Full Game', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_digitalRevenue_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        isIncludesSegmentValue('Full Game', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Digital Revenue(€)(In-Game Currency)',
      key: (item: any) =>
        item?.['metrics_gsd_digitalRevenue_segment_In-Game Currency'] || '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_digitalRevenue_segment_In-Game Currency_growth'] ||
        '',
      when: () =>
        metricsCache.gsd_digitalRevenue &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Revenue(€)',
      key: (item: any) => item?.metrics_gsd_physicalRevenue || '',
      when: () =>
        metricsCache.gsd_physicalRevenue && !params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_gsd_physicalRevenue_growth || '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        !params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Revenue(€)(Aggregated)',
      key: (item: any) =>
        item?.metrics_gsd_physicalRevenue_segment_Aggregated || '',
      when: () => metricsCache.gsd_physicalRevenue && params.b_group_by_segment,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gsd_physicalRevenue_segment_Aggregated_growth || '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        params.b_group_by_segment &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Revenue(€)(Base Game)',
      key: (item: any) =>
        item?.['metrics_gsd_physicalRevenue_segment_Full Game'] || '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        isIncludesSegmentValue('Full Game', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_physicalRevenue_segment_Full Game_growth'] || '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        isIncludesSegmentValue('Full Game', params, 'gsd') &&
        isRatioShow,
    },
    {
      title: 'GSD Physical Revenue(€)(In-Game Currency)',
      key: (item: any) =>
        item?.['metrics_gsd_physicalRevenue_segment_In-Game Currency'] || '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd'),
    },
    {
      title: '%',
      key: (item: any) =>
        item?.['metrics_gsd_physicalRevenue_segment_In-Game Currency_growth'] ||
        '',
      when: () =>
        metricsCache.gsd_physicalRevenue &&
        isIncludesSegmentValue('In-Game Currency', params, 'gsd') &&
        isRatioShow,
    },
    // ============= Start Source Steam Metrics =============
    {
      title: 'Steam PCU',
      key: (item: any) =>
        item?.metrics_source_steam__pcu ||
        item?.metrics_source_steam__pcu_segment_All ||
        '',
      when: () => metricsCache.source_steam__pcu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_source_steam__pcu_growth ??
        item?.metrics_source_steam__pcu_segment_All_growth ??
        '',
      when: () => metricsCache.source_steam__pcu && isRatioShow,
    },
    {
      title: 'Steam ACU',
      key: (item: any) =>
        item?.metrics_source_steam__acu ||
        item?.metrics_source_steam__acu_segment_All ||
        '',
      when: () => metricsCache.source_steam__acu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_source_steam__acu_growth ??
        item?.metrics_source_steam__acu_segment_All_growth ??
        '',
      when: () => metricsCache.source_steam__acu && isRatioShow,
    },
    {
      title: 'Steam Followers',
      key: (item: any) =>
        item?.metrics_steamfollowers ||
        item?.metrics_steamfollowers_segment_All ||
        '',
      when: () => metricsCache.steamfollowers,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_steamfollowers_growth ??
        item?.metrics_steamfollowers_segment_All_growth ??
        '',
      when: () => metricsCache.steamfollowers && isRatioShow,
    },
    // ============= End Source Steam Metrics =============
    // ============= Alinea Metrics =============
    {
      title: 'Alinea Steam Revenue($)',
      key: (item: any) =>
        item?.metrics_alinea__est_revenue ||
        item?.metrics_alinea__est_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__est_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__est_revenue_growth ||
        item?.metrics_alinea__est_revenue_segment_All_growth ||
        '',
      when: () => metricsCache.alinea__est_revenue && isRatioShow,
    },
    {
      title: 'Alinea Steam Cumulative Revenue($)',
      key: (item: any) =>
        item?.metrics_alinea__est_cumulative_revenue ||
        item?.metrics_alinea__est_cumulative_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__est_cumulative_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__est_cumulative_revenue_growth ??
        item?.metrics_alinea__est_cumulative_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__est_cumulative_revenue && isRatioShow,
    },
    {
      title: 'Alinea Steam Units',
      key: (item: any) =>
        item?.metrics_alinea__est_units ||
        item?.metrics_alinea__est_units_segment_All ||
        '',
      when: () => metricsCache.alinea__est_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__est_units_growth ??
        item?.metrics_alinea__est_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__est_units && isRatioShow,
    },
    {
      title: 'Alinea Steam Cumulative Units',
      key: (item: any) =>
        item?.metrics_alinea__est_cumulative_units ||
        item?.metrics_alinea__est_cumulative_units_segment_All ||
        '',
      when: () => metricsCache.alinea__est_cumulative_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__est_cumulative_units_growth ??
        item?.metrics_alinea__est_cumulative_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__est_cumulative_units && isRatioShow,
    },
    {
      title: 'Alinea Steam PCU',
      key: (item: any) =>
        item?.metrics_alinea__pcu || item?.metrics_alinea__pcu_segment_All || '',
      when: () => metricsCache.alinea__pcu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__pcu_growth ?? item?.metrics_alinea__pcu_segment_All_growth ?? '',
      when: () => metricsCache.alinea__pcu && isRatioShow,
    },
    {
      title: 'Alinea Steam ACU',
      key: (item: any) =>
        item?.metrics_alinea__acu || item?.metrics_alinea__acu_segment_All || '',
      when: () => metricsCache.alinea__acu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__acu_growth ?? item?.metrics_alinea__acu_segment_All_growth ?? '',
      when: () => metricsCache.alinea__acu && isRatioShow,
    },
    {
      title: 'Alinea MAU',
      key: (item: any) =>
        item?.metrics_alinea__mau ||
        item?.metrics_alinea__mau_segment_All ||
        '',
      when: () => metricsCache.alinea__mau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__mau_growth ??
        item?.metrics_alinea__mau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__mau && isRatioShow,
    },
    {
      title: 'Alinea DAU',
      key: (item: any) =>
        item?.metrics_alinea__dau ||
        item?.metrics_alinea__dau_segment_All ||
        '',
      when: () => metricsCache.alinea__dau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__dau_growth ??
        item?.metrics_alinea__dau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__dau && isRatioShow,
    },
    {
      title: 'Alinea Steam Avg. Playtime(mins)',
      key: (item: any) =>
        item?.metrics_alinea__playtime ||
        item?.metrics_alinea__playtime_segment_All ||
        '',
      when: () => metricsCache.alinea__playtime,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__playtime_growth ??
        item?.metrics_alinea__playtime_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__playtime && isRatioShow,
    },
    {
      title: 'Alinea Steam Players',
      key: (item: any) =>
        item?.metrics_alinea__players ??
        item?.metrics_alinea__players_segment_All ??
        '',
      when: () => metricsCache.alinea__players,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__players_growth ??
        item?.metrics_alinea__players_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__players && isRatioShow,
    },
    {
      title: 'Alinea Steam Total Players',
      key: (item: any) =>
        item?.metrics_alinea__players_total ??
        item?.metrics_alinea__players_total_segment_All ??
        '',
      when: () => metricsCache.alinea__players_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__players_total_growth ??
        item?.metrics_alinea__players_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__players_total && isRatioShow,
    },
    {
      title: 'Alinea Steam Players by Country',
      key: (item: any) =>
        item?.metrics_alinea__players_by_country ||
        item?.metrics_alinea__players_by_country_segment_All ||
        '',
      when: () => metricsCache.alinea__players_by_country,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__players_by_country_growth ??
        item?.metrics_alinea__players_by_country_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__players_by_country && isRatioShow,
    },
    {
      title: 'Alinea Steam Wishlists by Countries',
      key: (item: any) =>
        item?.metrics_alinea__wishlists_by_country ||
        item?.metrics_alinea__wishlists_by_country_segment_All ||
        '',
      when: () => metricsCache.alinea__wishlists_by_country,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__wishlists_by_country_growth ??
        item?.metrics_alinea__wishlists_by_country_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__wishlists_by_country && isRatioShow,
    },
    {
      title: 'Alinea Steam Followers',
      key: (item: any) =>
        item?.metrics_alinea__steamfollowers ||
        item?.metrics_alinea__steamfollowers_segment_All ||
        '',
      when: () => metricsCache.alinea__steamfollowers,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__steamfollowers_growth ??
        item?.metrics_alinea__steamfollowers_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__steamfollowers && isRatioShow,
    },
    {
      title: 'Alinea Steam Daily Wishlist',
      key: (item: any) =>
        item?.metrics_alinea__wishlists ||
        item?.metrics_alinea__wishlists_segment_All ||
        '',
      when: () => metricsCache.alinea__wishlists,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__wishlists_growth ??
        item?.metrics_alinea__wishlists_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__wishlists && isRatioShow,
    },
    {
      title: 'Alinea Steam Lifetime Wishlist',
      key: (item: any) =>
        item?.metrics_alinea__wishlists_total ||
        item?.metrics_alinea__wishlists_total_segment_All ||
        '',
      when: () => metricsCache.alinea__wishlists_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__wishlists_total_growth ??
        item?.metrics_alinea__wishlists_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__wishlists_total && isRatioShow,
    },
    {
      title: 'Alinea Steam Price($)',
      key: (item: any) =>
        item?.metrics_alinea__est_price ||
        item?.metrics_alinea__est_price_segment_All ||
        '',
      when: () => metricsCache.alinea__est_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__est_price_growth ||
        item?.metrics_alinea__est_price_segment_All_growth ||
        '',
      when: () => metricsCache.alinea__est_price && isRatioShow,
    },
    {
      title: 'Alinea Steam Lifetime Weighted Price($)',
      key: (item: any) =>
        item?.metrics_alinea__lifetime_weighted_price ||
        item?.metrics_alinea__lifetime_weighted_price_segment_All ||
        '',
      when: () => metricsCache.alinea__lifetime_weighted_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__lifetime_weighted_price_growth ??
        item?.metrics_alinea__lifetime_weighted_price_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__lifetime_weighted_price && isRatioShow,
    },
    {
      title: 'Alinea Steam Reviews',
      key: (item: any) =>
        item?.metrics_alinea__steamreviews ||
        item?.metrics_alinea__steamreviews_segment_All ||
        '',
      when: () => metricsCache.alinea__steamreviews,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__steamreviews_growth ??
        item?.metrics_alinea__steamreviews_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__steamreviews && isRatioShow,
    },
    {
      title: 'Alinea Steam Total Reviews',
      key: (item: any) =>
        item?.metrics_alinea__cumulative_reviews ??
        item?.metrics_alinea__cumulative_reviews_segment_All ??
        '',
      when: () => metricsCache.alinea__cumulative_reviews,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__cumulative_reviews_growth ??
        item?.metrics_alinea__cumulative_reviews_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__cumulative_reviews && isRatioShow,
    },
    {
      title: 'Alinea Steam Positive Reviews',
      key: (item: any) =>
        item?.metrics_alinea__positive ??
        item?.metrics_alinea__positive_segment_All ??
        '',
      when: () => metricsCache.alinea__positive,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__positive_growth ??
        item?.metrics_alinea__positive_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__positive && isRatioShow,
    },
    {
      title: 'Alinea Steam Total Positive Reviews',
      key: (item: any) =>
        item?.metrics_alinea__cumulative_positive ??
        item?.metrics_alinea__cumulative_positive_segment_All ??
        '',
      when: () => metricsCache.alinea__cumulative_positive,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__cumulative_positive_growth ??
        item?.metrics_alinea__cumulative_positive_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__cumulative_positive && isRatioShow,
    },
    {
      title: 'Alinea PS Players by Country',
      key: (item: any) =>
        item?.metrics_alinea__ps_players_by_country ||
        item?.metrics_alinea__ps_players_by_country_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_players_by_country,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_players_by_country_growth ??
        item?.metrics_alinea__ps_players_by_country_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_players_by_country && isRatioShow,
    },
    {
      title: 'Alinea PS Revenue',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_revenue ||
        item?.metrics_alinea__ps_est_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_est_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_revenue_growth ??
        item?.metrics_alinea__ps_est_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_est_revenue && isRatioShow,
    },
    {
      title: 'Alinea PS Revenue Total',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_cumulative_revenue ||
        item?.metrics_alinea__ps_est_cumulative_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_est_cumulative_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_cumulative_revenue_growth ??
        item?.metrics_alinea__ps_est_cumulative_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_est_cumulative_revenue && isRatioShow,
    },
    {
      title: 'Alinea PS Units',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_units ||
        item?.metrics_alinea__ps_est_units_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_est_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_units_growth ??
        item?.metrics_alinea__ps_est_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_est_units && isRatioShow,
    },
    {
      title: 'Alinea PS Units Total',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_cumulative_units ||
        item?.metrics_alinea__ps_est_cumulative_units_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_est_cumulative_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_est_cumulative_units_growth ??
        item?.metrics_alinea__ps_est_cumulative_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_est_cumulative_units && isRatioShow,
    },
    {
      title: 'Alinea PS Players',
      key: (item: any) =>
        item?.metrics_alinea__ps_players ||
        item?.metrics_alinea__ps_players_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_players,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_players_growth ??
        item?.metrics_alinea__ps_players_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_players && isRatioShow,
    },
    {
      title: 'Alinea PS Total Players',
      key: (item: any) =>
        item?.metrics_alinea__ps_players_total ||
        item?.metrics_alinea__ps_players_total_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_players_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_players_total_growth ??
        item?.metrics_alinea__ps_players_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_players_total && isRatioShow,
    },
    {
      title: 'Alinea PS Game Pass Players',
      key: (item: any) =>
        item?.metrics_alinea__ps_game_pass_players ||
        item?.metrics_alinea__ps_game_pass_players_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_game_pass_players,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_game_pass_players_growth ??
        item?.metrics_alinea__ps_game_pass_players_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_game_pass_players && isRatioShow,
    },
    {
      title: 'Alinea PS Game Pass Total Players',
      key: (item: any) =>
        item?.metrics_alinea__ps_game_pass_players_total ||
        item?.metrics_alinea__ps_game_pass_players_total_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_game_pass_players_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_game_pass_players_total_growth ??
        item?.metrics_alinea__ps_game_pass_players_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_game_pass_players_total && isRatioShow,
    },
    {
      title: 'Alinea PS DAU',
      key: (item: any) =>
        item?.metrics_alinea__ps_dau ||
        item?.metrics_alinea__ps_dau_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_dau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_dau_growth ??
        item?.metrics_alinea__ps_dau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_dau && isRatioShow,
    },
    {
      title: 'Alinea PS MAU',
      key: (item: any) =>
        item?.metrics_alinea__ps_mau ||
        item?.metrics_alinea__ps_mau_segment_All ||
        '',
      when: () => metricsCache.alinea__ps_mau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__ps_mau_growth ??
        item?.metrics_alinea__ps_mau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__ps_mau && isRatioShow,
    },
    {
      title: 'Alinea Xbox Revenue',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_revenue ||
        item?.metrics_alinea__xbox_est_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_est_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_revenue_growth ??
        item?.metrics_alinea__xbox_est_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_est_revenue && isRatioShow,
    },
    {
      title: 'Alinea Xbox Revenue Total',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_cumulative_revenue ||
        item?.metrics_alinea__xbox_est_cumulative_revenue_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_est_cumulative_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_cumulative_revenue_growth ??
        item?.metrics_alinea__xbox_est_cumulative_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_est_cumulative_revenue && isRatioShow,
    },
    {
      title: 'Alinea Xbox Units',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_units ||
        item?.metrics_alinea__xbox_est_units_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_est_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_units_growth ??
        item?.metrics_alinea__xbox_est_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_est_units && isRatioShow,
    },
    {
      title: 'Alinea Xbox Units Total',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_cumulative_units ||
        item?.metrics_alinea__xbox_est_cumulative_units_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_est_cumulative_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_est_cumulative_units_growth ??
        item?.metrics_alinea__xbox_est_cumulative_units_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_est_cumulative_units && isRatioShow,
    },
    {
      title: 'Alinea Xbox Players',
      key: (item: any) =>
        item?.metrics_alinea__xbox_players ||
        item?.metrics_alinea__xbox_players_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_players,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_players_growth ??
        item?.metrics_alinea__xbox_players_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_players && isRatioShow,
    },
    {
      title: 'Alinea Xbox Total Players',
      key: (item: any) =>
        item?.metrics_alinea__xbox_players_total ||
        item?.metrics_alinea__xbox_players_total_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_players_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_players_total_growth ??
        item?.metrics_alinea__xbox_players_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_players_total && isRatioShow,
    },
    {
      title: 'Alinea Xbox Game Pass Players',
      key: (item: any) =>
        item?.metrics_alinea__xbox_game_pass_players ||
        item?.metrics_alinea__xbox_game_pass_players_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_game_pass_players,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_game_pass_players_growth ??
        item?.metrics_alinea__xbox_game_pass_players_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_game_pass_players && isRatioShow,
    },
    {
      title: 'Alinea Xbox Game Pass Total Players',
      key: (item: any) =>
        item?.metrics_alinea__xbox_game_pass_players_total ||
        item?.metrics_alinea__xbox_game_pass_players_total_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_game_pass_players_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_game_pass_players_total_growth ??
        item?.metrics_alinea__xbox_game_pass_players_total_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_game_pass_players_total && isRatioShow,
    },
    {
      title: 'Alinea Xbox DAU',
      key: (item: any) =>
        item?.metrics_alinea__xbox_dau ||
        item?.metrics_alinea__xbox_dau_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_dau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_dau_growth ??
        item?.metrics_alinea__xbox_dau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_dau && isRatioShow,
    },
    {
      title: 'Alinea Xbox MAU',
      key: (item: any) =>
        item?.metrics_alinea__xbox_mau ||
        item?.metrics_alinea__xbox_mau_segment_All ||
        '',
      when: () => metricsCache.alinea__xbox_mau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_alinea__xbox_mau_growth ??
        item?.metrics_alinea__xbox_mau_segment_All_growth ??
        '',
      when: () => metricsCache.alinea__xbox_mau && isRatioShow,
    },
    // ============= End Alinea Metrics =============
    {
      title: 'DAU',
      key: (item: any) => item?.metrics_ampere_dau || '',
      when: () => metricsCache.ampere_dau && params.granularity === 'daily',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_dau_growth || '',
      when: () =>
        metricsCache.ampere_dau &&
        params.granularity === 'daily' &&
        isRatioShow,
    },
    {
      title: 'New DAU',
      key: (item: any) => item?.metrics_ampere_new_dau || '',
      when: () => metricsCache.ampere_new_dau && params.granularity === 'daily',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_new_dau_growth || '',
      when: () =>
        metricsCache.ampere_new_dau &&
        params.granularity === 'daily' &&
        isRatioShow,
    },

    {
      title: 'MAU',
      key: (item: any) => item?.metrics_ampere_mau || '',
      when: () => metricsCache.ampere_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_mau_growth || '',
      when: () =>
        metricsCache.ampere_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'Previous MAU',
      key: (item: any) => item?.metrics_ampere_previous_mau || '',
      when: () =>
        metricsCache.ampere_previous_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_previous_mau_growth || '',
      when: () =>
        metricsCache.ampere_previous_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },

    {
      title: 'Added Users',
      key: (item: any) => item?.metrics_ampere_added_mau || '',
      when: () =>
        metricsCache.ampere_added_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_added_mau_growth || '',
      when: () =>
        metricsCache.ampere_added_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'New MAU',
      key: (item: any) => item?.metrics_ampere_new_mau || '',
      when: () =>
        metricsCache.ampere_new_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_new_mau_growth || '',
      when: () =>
        metricsCache.ampere_new_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'Retained Users',
      key: (item: any) => item?.metrics_ampere_retained_mau || '',
      when: () =>
        metricsCache.ampere_retained_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_retained_mau_growth || '',
      when: () =>
        metricsCache.ampere_retained_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'Churned Users',
      key: (item: any) => item?.metrics_ampere_churned_mau || '',
      when: () =>
        metricsCache.ampere_churned_mau && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_churned_mau_growth || '',
      when: () =>
        metricsCache.ampere_churned_mau &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },

    {
      title: 'Avg Daily Playtime (hours)',
      key: (item: any) => item?.metrics_ampere_avg_dailly_playtime || '',
      when: () =>
        metricsCache.ampere_avg_dailly_playtime &&
        params.granularity === 'daily',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_avg_dailly_playtime_growth || '',
      when: () =>
        metricsCache.ampere_avg_dailly_playtime &&
        params.granularity === 'daily' &&
        isRatioShow,
    },
    {
      title: 'Avg Monthly Playtime (hours)',
      key: (item: any) => item?.metrics_ampere_avg_monthly_playtime || '',
      when: () =>
        metricsCache.ampere_avg_monthly_playtime &&
        params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_ampere_avg_monthly_playtime_growth || '',
      when: () =>
        metricsCache.ampere_avg_monthly_playtime &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'Acquisition Rate',
      key: (item: any) => item?.metrics_ampere_acquisition_rate || '',
      when: () =>
        metricsCache.ampere_acquisition_rate &&
        params.granularity === 'monthly',
    },
    {
      title: 'Stickiness',
      key: (item: any) => item?.metrics_ampere_stickiness || '',
      when: () =>
        metricsCache.ampere_stickiness && params.granularity === 'monthly',
    },
    {
      title: 'Lifetime Players',
      key: (item: any) => item?.metrics_ampere_lifetime_users || '',
      when: () =>
        metricsCache.ampere_lifetime_users && params.granularity === 'monthly',
    },
    {
      title: '%',
      key: (item: any) => item?.metrics_ampere_lifetime_users_growth || '',
      when: () =>
        metricsCache.ampere_lifetime_users &&
        params.granularity === 'monthly' &&
        isRatioShow,
    },
    {
      title: 'D1',
      key: (item: any) => item?.metrics_ampere_d1 || '',
      when: () => metricsCache.ampere_d1,
    },
    {
      title: 'D7',
      key: (item: any) => item?.metrics_ampere_d7 || '',
      when: () => metricsCache.ampere_d7,
    },
    {
      title: 'D14',
      key: (item: any) => item?.metrics_ampere_d14 || '',
      when: () => metricsCache.ampere_d14,
    },
    {
      title: 'D28',
      key: (item: any) => item?.metrics_ampere_d28 || '',
      when: () => metricsCache.ampere_d28,
    },
    {
      title: 'D60',
      key: (item: any) => item?.metrics_ampere_d60 || '',
      when: () => metricsCache.ampere_d60,
    },
    {
      title: 'Rolling D1',
      key: (item: any) => item?.metrics_ampere_rolling_d1 || '',
      when: () => metricsCache.ampere_rolling_d1,
    },
    {
      title: 'Rolling D7',
      key: (item: any) => item?.metrics_ampere_rolling_d7 || '',
      when: () => metricsCache.ampere_rolling_d7,
    },
    {
      title: 'Rolling D14',
      key: (item: any) => item?.metrics_ampere_rolling_d14 || '',
      when: () => metricsCache.ampere_rolling_d14,
    },
    {
      title: 'Rolling D28',
      key: (item: any) => item?.metrics_ampere_rolling_d28 || '',
      when: () => metricsCache.ampere_rolling_d28,
    },
    {
      title: 'Rolling D60',
      key: (item: any) => item?.metrics_ampere_rolling_d60 || '',
      when: () => metricsCache.ampere_rolling_d60,
    },
    // ============= Gamalytic Metrics =============
    {
      title: 'Gamalytic Steam Revenue($)',
      key: (item: any) =>
        item?.metrics_gamalytic__est_revenue ||
        item?.metrics_gamalytic__est_revenue_segment_All ||
        '',
      when: () => metricsCache.gamalytic__est_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__est_revenue_growth ||
        item?.metrics_gamalytic__est_revenue_segment_All_growth ||
        '',
      when: () => metricsCache.gamalytic__est_revenue && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Cumulative Revenue($)',
      key: (item: any) =>
        item?.metrics_gamalytic__est_cumulative_revenue ||
        item?.metrics_gamalytic__est_cumulative_revenue_segment_All ||
        '',
      when: () => metricsCache.gamalytic__est_cumulative_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__est_cumulative_revenue_growth ??
        item?.metrics_gamalytic__est_cumulative_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__est_cumulative_revenue && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Units',
      key: (item: any) =>
        item?.metrics_gamalytic__est_units ||
        item?.metrics_gamalytic__est_units_segment_All ||
        '',
      when: () => metricsCache.gamalytic__est_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__est_units_growth ??
        item?.metrics_gamalytic__est_units_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__est_units && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Cumulative Units',
      key: (item: any) =>
        item?.metrics_gamalytic__est_cumulative_units ||
        item?.metrics_gamalytic__est_cumulative_units_segment_All ||
        '',
      when: () => metricsCache.gamalytic__est_cumulative_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__est_cumulative_units_growth ??
        item?.metrics_gamalytic__est_cumulative_units_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__est_cumulative_units && isRatioShow,
    },
    {
      title: 'Gamalytic Steam PCU',
      key: (item: any) =>
        item?.metrics_gamalytic__pcu || item?.metrics_gamalytic__pcu_segment_All || '',
      when: () => metricsCache.gamalytic__pcu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__pcu_growth ?? item?.metrics_gamalytic__pcu_segment_All_growth ?? '',
      when: () => metricsCache.gamalytic__pcu && isRatioShow,
    },
    {
      title: 'Gamalytic Steam ACU',
      key: (item: any) =>
        item?.metrics_gamalytic__acu || item?.metrics_gamalytic__acu_segment_All || '',
      when: () => metricsCache.gamalytic__acu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__acu_growth ?? item?.metrics_gamalytic__acu_segment_All_growth ?? '',
      when: () => metricsCache.gamalytic__acu && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Avg. Playtime(hours)',
      key: (item: any) =>
        item?.metrics_gamalytic__playtime ||
        item?.metrics_gamalytic__playtime_segment_All ||
        '',
      when: () => metricsCache.gamalytic__playtime,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__playtime_growth ??
        item?.metrics_gamalytic__playtime_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__playtime && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Players by Country',
      key: (item: any) =>
        item?.metrics_gamalytic__players_by_country ||
        item?.metrics_gamalytic__players_by_country_segment_All ||
        '',
      when: () => metricsCache.gamalytic__players_by_country,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__players_by_country_growth ??
        item?.metrics_gamalytic__players_by_country_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__players_by_country && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Followers',
      key: (item: any) =>
        item?.metrics_gamalytic__steamfollowers ||
        item?.metrics_gamalytic__steamfollowers_segment_All ||
        '',
      when: () => metricsCache.gamalytic__steamfollowers,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__steamfollowers_growth ??
        item?.metrics_gamalytic__steamfollowers_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__steamfollowers && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Daily Wishlist',
      key: (item: any) =>
        item?.metrics_gamalytic__wishlists ||
        item?.metrics_gamalytic__wishlists_segment_All ||
        '',
      when: () => metricsCache.gamalytic__wishlists,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__wishlists_growth ??
        item?.metrics_gamalytic__wishlists_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__wishlists && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Lifetime Wishlist',
      key: (item: any) =>
        item?.metrics_gamalytic__wishlists_total ||
        item?.metrics_gamalytic__wishlists_total_segment_All ||
        '',
      when: () => metricsCache.gamalytic__wishlists_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__wishlists_total_growth ??
        item?.metrics_gamalytic__wishlists_total_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__wishlists_total && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Price($)',
      key: (item: any) =>
        item?.metrics_gamalytic__est_price ||
        item?.metrics_gamalytic__est_price_segment_All ||
        '',
      when: () => metricsCache.gamalytic__est_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__est_price_growth ||
        item?.metrics_gamalytic__est_price_segment_All_growth ||
        '',
      when: () => metricsCache.gamalytic__est_price && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Lifetime Weighted Price($)',
      key: (item: any) =>
        item?.metrics_gamalytic__lifetime_weighted_price ||
        item?.metrics_gamalytic__lifetime_weighted_price_segment_All ||
        '',
      when: () => metricsCache.gamalytic__lifetime_weighted_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__lifetime_weighted_price_growth ??
        item?.metrics_gamalytic__lifetime_weighted_price_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__lifetime_weighted_price && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Reviews',
      key: (item: any) =>
        item?.metrics_gamalytic__steamreviews ||
        item?.metrics_gamalytic__steamreviews_segment_All ||
        '',
      when: () => metricsCache.gamalytic__steamreviews,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__steamreviews_growth ??
        item?.metrics_gamalytic__steamreviews_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__steamreviews && isRatioShow,
    },
    {
      title: 'Gamalytic Steam Total Reviews',
      key: (item: any) =>
        item?.metrics_gamalytic__cumulative_reviews ??
        item?.metrics_gamalytic__cumulative_reviews_segment_All ??
        '',
      when: () => metricsCache.gamalytic__cumulative_reviews,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__cumulative_reviews_growth ??
        item?.metrics_gamalytic__cumulative_reviews_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__cumulative_reviews && isRatioShow,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_gamalytic__steamfollowers_growth ??
        item?.metrics_gamalytic__steamfollowers_segment_All_growth ??
        '',
      when: () => metricsCache.gamalytic__steamfollowers && isRatioShow,
    },
    // ============= End Gamalytic Metrics =============
    // ============= Start VGI Metrics =============
    {
      title: 'VGI Steam Premium Revenue($)',
      key: (item: any) =>
        item?.metrics_est_revenue ||
        item?.metrics_est_revenue_segment_All ||
        '',
      when: () => metricsCache.est_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_est_revenue_growth ??
        item?.metrics_est_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.est_revenue && isRatioShow,
    },
    {
      title: 'VGI Steam Cumulative Revenue($)',
      key: (item: any) =>
        item?.metrics_est_cumulative_revenue ||
        item?.metrics_est_cumulative_revenue_segment_All ||
        '',
      when: () => metricsCache.est_cumulative_revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_est_cumulative_revenue_growth ??
        item?.metrics_est_cumulative_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.est_cumulative_revenue && isRatioShow,
    },
    {
      title: 'VGI Steam Units',
      key: (item: any) =>
        item?.metrics_est_units || item?.metrics_est_units_segment_All || '',
      when: () => metricsCache.est_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_est_units_growth ??
        item?.metrics_est_units_segment_All_growth ??
        '',
      when: () => metricsCache.est_units && isRatioShow,
    },
    {
      title: 'VGI Steam Cumulative Units',
      key: (item: any) =>
        item?.metrics_est_cumulative_units ||
        item?.metrics_est_cumulative_units_segment_All ||
        '',
      when: () => metricsCache.est_cumulative_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_est_cumulative_units_growth ??
        item?.metrics_est_cumulative_units_segment_All_growth ??
        '',
      when: () => metricsCache.est_cumulative_units && isRatioShow,
    },
    {
      title: 'VGI Steam PCU',
      key: (item: any) =>
        item?.metrics_pcu || item?.metrics_pcu_segment_All || '',
      when: () => metricsCache.pcu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_pcu_growth ?? item?.metrics_pcu_segment_All_growth ?? '',
      when: () => metricsCache.pcu && isRatioShow,
    },
    {
      title: 'VGI Steam ACU',
      key: (item: any) =>
        item?.metrics_acu || item?.metrics_acu_segment_All || '',
      when: () => metricsCache.acu,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_acu_growth ?? item?.metrics_acu_segment_All_growth ?? '',
      when: () => metricsCache.acu && isRatioShow,
    },
    {
      title: 'VGI Steam Avg. Playtime(mins)',
      key: (item: any) =>
        item?.metrics_playtime || item?.metrics_playtime_segment_All || '',
      when: () => metricsCache.playtime,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_playtime_growth ??
        item?.metrics_playtime_segment_All_growth ??
        '',
      when: () => metricsCache.playtime && isRatioShow,
    },
    {
      title: 'VGI Steam Players by Country',
      key: (item: any) =>
        item?.metrics_players_by_country || item?.metrics_players_by_country_segment_All || '',
      when: () => metricsCache.players_by_country,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_players_by_country_growth ??
        item?.metrics_players_by_country_segment_All_growth ??
        '',
      when: () => metricsCache.players_by_country && isRatioShow,
    },
    {
      title: 'VGI Steam Daily Wishlist',
      key: (item: any) =>
        item?.metrics_wishlists || item?.metrics_wishlists_segment_All || '',
      when: () => metricsCache.wishlists,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_wishlists_growth ??
        item?.metrics_wishlists_segment_All_growth ??
        '',
      when: () => metricsCache.wishlists && isRatioShow,
    },
    {
      title: 'VGI Steam Lifetime Wishlist',
      key: (item: any) =>
        item?.metrics_wishlists_total ||
        item?.metrics_wishlists_total_segment_All ||
        '',
      when: () => metricsCache.wishlists_total,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_wishlists_total_growth ??
        item?.metrics_wishlists_total_segment_All_growth ??
        '',
      when: () => metricsCache.wishlists_total && isRatioShow,
    },
    {
      title: 'VGI Steam Price($)',
      key: (item: any) =>
        item?.metrics_est_price || item?.metrics_est_price_segment_All || '',
      when: () => metricsCache.est_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_est_price_growth ??
        item?.metrics_est_price_segment_All_growth ??
        '',
      when: () => metricsCache.est_price && isRatioShow,
    },
    {
      title: 'VGI Steam Lifetime Weighted Price($)',
      key: (item: any) =>
        item?.metrics_lifetime_weighted_price ||
        item?.metrics_lifetime_weighted_price_segment_All ||
        '',
      when: () => metricsCache.lifetime_weighted_price,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_lifetime_weighted_price_growth ??
        item?.metrics_lifetime_weighted_price_segment_All_growth ??
        '',
      when: () => metricsCache.lifetime_weighted_price && isRatioShow,
    },
    {
      title: 'VGI Steam Reviews',
      key: (item: any) =>
        item?.metrics_steamreviews ||
        item?.metrics_steamreviews_segment_All ||
        '',
      when: () => metricsCache.steamreviews,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_steamreviews_growth ??
        item?.metrics_steamreviews_segment_All_growth ??
        '',
      when: () => metricsCache.steamreviews && isRatioShow,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_followers_growth ??
        item?.metrics_followers_segment_All_growth ??
        '',
      when: () => metricsCache.followers && isRatioShow,
    },
    // ============= End VGI Metrics =============
    {
      title: 'NPD Physical Revenue',
      key: (item: any) =>
        item?.metrics_revenue || item?.metrics_revenue_segment_All || '',
      when: () => metricsCache.revenue,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_revenue_growth ??
        item?.metrics_revenue_segment_All_growth ??
        '',
      when: () => metricsCache.revenue && isRatioShow,
    },
    {
      title: 'NPD Physical Units',
      key: (item: any) =>
        item?.metrics_physical_units ||
        item?.metrics_physical_units_segment_All ||
        '',
      when: () => metricsCache.physical_units,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_physical_units_growth ??
        item?.metrics_physical_units_segment_All_growth ??
        '',
      when: () => metricsCache.physical_units && isRatioShow,
    },

    {
      title: 'MAU(no-update)',
      key: (item: any) =>
        item?.metrics_mau || item?.metrics_mau_segment_All || '',
      when: () => metricsCache.mau,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_mau_growth ?? item?.metrics_mau_segment_All_growth ?? '',
      when: () => metricsCache.mau && isRatioShow,
    },
    {
      title: 'Player Share',
      key: (item: any) =>
        item?.metrics_player_share ||
        item?.metrics_player_share_segment_All ||
        '',
      when: () => metricsCache.player_share,
    },
    {
      title: 'MAU growth(no-update)',
      key: (item: any) =>
        item?.metrics_mau_growth || item?.metrics_mau_growth_segment_All || '',
      when: () => metricsCache.mau_growth,
    },
    {
      title: 'MAU new(no-update)',
      key: (item: any) =>
        item?.metrics_mau_new || item?.metrics_mau_new_segment_All || '',
      when: () => metricsCache.mau_new,
    },
    {
      title: 'MAU Returning(no-update)',
      key: (item: any) =>
        item?.metrics_mau_returning ||
        item?.metrics_mau_returning_segment_All ||
        '',
      when: () => metricsCache.mau_returning,
    },
    {
      title: 'Lifetime Players(no-update)',
      key: (item: any) =>
        item?.metrics_lifetime_player ||
        item?.metrics_lifetime_player_segment_All ||
        '',
      when: () => metricsCache.lifetime_player,
    },
    {
      title: 'Avg Daily Playtime(mins)(no-update)',
      key: (item: any) =>
        item?.metrics_avg_daily_playtime ||
        item?.metrics_avg_daily_playtime_segment_All ||
        '',
      when: () => metricsCache.avg_daily_playtime,
    },
    {
      title: 'Avg Daily Sessions(no-update)',
      key: (item: any) =>
        item?.metrics_avg_daily_sessions ||
        item?.metrics_avg_daily_sessions_segment_All ||
        '',
      when: () => metricsCache.avg_daily_sessions,
    },
    {
      title: 'Avg Days Played(no-update)',
      key: (item: any) =>
        item?.metrics_avg_playtime_per_session ||
        item?.metrics_avg_playtime_per_session_segment_All ||
        '',
      when: () => metricsCache.avg_playtime_per_session,
    },
    {
      title: 'Avg Monthly Playtime(hours)(no-update)',
      key: (item: any) =>
        item?.metrics_avg_monthly_playtime ||
        item?.metrics_avg_monthly_playtime_segment_All ||
        '',
      when: () => metricsCache.avg_monthly_playtime,
    },
    {
      title: 'Avg Monthly Sessions(no-update)',
      key: (item: any) =>
        item?.avg_monthly_sessions ||
        item?.metrics_avg_monthly_sessions_segment_All ||
        '',
      when: () => metricsCache.avg_monthly_sessions,
    },
    {
      title: 'Avg Playtime Per Session(mins)(no-update)',
      key: (item: any) =>
        item?.metrics_avg_days_played ||
        item?.metrics_avg_days_played_segment_All ||
        '',
      when: () => metricsCache.avg_days_played,
    },
    {
      title: 'Stickiness(no-update)',
      key: (item: any) =>
        item?.metrics_stickiness || item?.metrics_stickiness_segment_All || '',
      when: () => metricsCache.stickiness,
    },
    {
      title: 'Total Hours(no-update)',
      key: (item: any) =>
        item?.metrics_total_hours ||
        item?.metrics_total_hours_segment_All ||
        '',
      when: () => metricsCache.total_hours,
    },
    {
      title: 'Churn(no-update)',
      key: (item: any) =>
        item?.metrics_churn || item?.metrics_churn_segment_All || '',
      when: () => metricsCache.churn,
    },
    {
      title: 'Acquisition',
      key: (item: any) =>
        item?.metrics_acquisition ||
        item?.metrics_acquisition_segment_All ||
        '',
      when: () => metricsCache.acquisition,
    },
    {
      title: '%',
      key: (item: any) =>
        item?.metrics_acquisition_growth ??
        item?.metrics_acquisition_segment_All_growth ??
        '',
      when: () => metricsCache.acquisition && isRatioShow,
    },
    {
      title: 'Time Spent 0-1 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_0H ||
        item?.metrics_time_spent_0H_segment_All ||
        '',
      when: () => metricsCache.time_spent_0H,
    },
    {
      title: 'Time Spent 1-5 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_1H ||
        item?.metrics_time_spent_1H_segment_All ||
        '',
      when: () => metricsCache.time_spent_1H,
    },
    {
      title: 'Time Spent 5-10 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_5H ||
        item?.metrics_time_spent_5H_segment_All ||
        '',
      when: () => metricsCache.time_spent_5H,
    },
    {
      title: 'Time Spent 10-25 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_10H ||
        item?.metrics_time_spent_10H_segment_All ||
        '',
      when: () => metricsCache.time_spent_10H,
    },
    {
      title: 'Time Spent 25-50 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_25H ||
        item?.metrics_time_spent_25H_segment_All ||
        '',
      when: () => metricsCache.time_spent_25H,
    },
    {
      title: 'Time Spent > 50 hrs(no-update)',
      key: (item: any) =>
        item?.metrics_time_spent_0H ||
        item?.metrics_time_spent_50H_segment_All ||
        '',
      when: () => metricsCache.time_spent_50H,
    },
    {
      title: 'D1(no-update)',
      key: (item: any) => item?.retention_d1 || '',
      when: () => metricsCache.retention_d1,
    },
    {
      title: 'D2(no-update)',
      key: (item: any) => item?.retention_d2 || '',
      when: () => metricsCache.retention_d2,
    },
    {
      title: 'D4(no-update)',
      key: (item: any) => item?.retention_d4 || '',
      when: () => metricsCache.retention_d4,
    },
    {
      title: 'D7(no-update)',
      key: (item: any) => item?.retention_d7 || '',
      when: () => metricsCache.retention_d7,
    },
    {
      title: 'D14(no-update)',
      key: (item: any) => item?.retention_d14 || '',
      when: () => metricsCache.retention_d14,
    },
    {
      title: 'D28(no-update)',
      key: (item: any) => item?.retention_d28 || '',
      when: () => metricsCache.retention_d28,
    },
  ];

  const orderedMetricKeys = getOrderedMetricEntriesFromParams(params).map(
    ({ metric }) => metric,
  );

  const usePlayersCountryPivot =
    shouldPivotPlayersByCountry(metricsCache, params) &&
    Array.isArray(targetList) &&
    targetList.length > 0;

  const statSheetData = usePlayersCountryPivot
    ? (() => {
        const {
          pivoted,
          markets,
          countryMetricNames,
          flatMetricNames,
        } = pivotPlayersByCountryTargetList(
          targetList,
          metricsCache,
          params,
          regionOptions,
          isRatioShow,
          orderedMetricKeys,
        );
        const pivotCfg = buildPlayersCountryPivotStatConfig(
          params,
          markets,
          isRatioShow,
          countryMetricNames,
          flatMetricNames,
          data?.name ?? '',
          regionOptions,
        );
        return buildDownloadDataNew(pivotCfg, pivoted);
      })()
    : buildDownloadDataNew(
        moveCountryDistributionStatColumnsLast(statConfig),
        targetList,
      );

  config.stat = {
    sheetName: 'Stats',
    style: 'normal',
    data: statSheetData,
  };

  // summary 直接用二维结果写
  config.summary = {
    sheetName: 'Summary',
    style: 'summary',
    data: [
      ...(() => {
        {
          let headTitle = ['Game Name'];
          let headValue = [data.name];
          if (params.company_show) {
            headTitle = [
              ...headTitle,
              'Company Name',
              'Company HQ Name',
              'Parent Company',
            ];
            headValue = [
              ...headValue,
              data.publisher,
              data.publisher_addr,
              data.parent_publisher,
            ];
          }
          if (params.genre_show) {
            headTitle = [...headTitle, 'IEGG Main Genre', 'IEGG Sub Genre'];
            headValue = [...headValue, data.iegg_genre, data.iegg_sub_genre];
          }
          if (params.release_date_show) {
            headTitle = [...headTitle, 'Release Date'];
            headValue = [...headValue, data.release_time];
          }
          if (params.steam_id_show) {
            headTitle = [...headTitle, 'Steam ID'];
            headValue = [...headValue, data.steam_id];
          }
          return [headTitle, headValue];
        }
      })(),
      ['', ''],
      [
        'Region/countries',
        Array.isArray(params?.markets) ? params?.markets?.join(',') : '',
      ],
      ['Date Start', params.start_date],
      ['Date End', params.end_date],
      ...(() => {
        // 输出metrics
        const result: any[] = [];
        const metricKeys = expandMultiValueMetricsForDownloadSummary(
          getOrderedMetricEntriesFromParams(allParams).map(
            ({ metric }) => metric,
          ),
          targetList,
        );
        metricKeys.forEach((item, index) => {
          const metrics: any[] = [];
          if (index === 0) {
            metrics.push('Metrics');
          } else {
            metrics.push('');
          }
          metrics.push(
            metricTitleMap[item] || getMultiValueMetricDownloadTitle(item),
          );
          result.push(metrics);
        });
        return result;
      })(),
      // Steam Tags
      (() => {
        const steamTagsListStr = data?.steam_tag?.split('|')?.join(',') || '';
        return [
          'Steam Tags',
          allParams.steam_tag_show === 0 ? '' : steamTagsListStr,
        ];
      })(),
      // Game Modes
      (() => {
        const gameModesListStr = data?.game_mode?.split('|')?.join(',') || '';
        return [
          'Game Modes',
          allParams.game_mode_show === 0 ? '' : gameModesListStr,
        ];
      })(),
      // Time Settings
      ['Time Settings', params.b_group_by_date ? 'Aggregated' : 'Separate'],
      ['File Format', allParams.file_format === 0 ? 'Excel' : 'CSV'],
    ],
  };

  return config;
}
